import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon, Badge, Menu, Button, Popover, Tabs, Select ,Input} from 'antd';

import SvgIcon from 'SvgIcon';
import SpinBar from 'yxyweb/common/components/common/SpinBar'
import { toggleLoadingStatus } from 'yxyweb/common/redux/loading'

const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const Search = Input.Search;
import ActionStatus from 'yxyweb/common/constants/ActionStatus';

import * as tabsactions from 'yxyweb/common/redux/tabs';
import * as portalactions from 'yxyweb/common/redux/portal';
import * as useractions from '../../redux/modules/user';

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trigger: process.env.__CLIENT__ && cb.rest.device === 'android' ? 'click' : 'hover',
      searchValue:''
    };
  }
  componentDidMount() {
    const { toggleLoadingStatus } = this.props;
    cb.utils.loading = function (status) {
      toggleLoadingStatus(status);
    }
    cb.events.on('personInfo', () => {
      this.handlePersonalInfo();
    });
    cb.events.on('redirectLogin', () => {
      this.handleLogout();
    });
  }
  handleAccountCenter() {
    const accountCenterKey = 'accountCenter';
    const { tabsactions, tabs } = this.props;
    const index = tabs.panes.findIndex(pane => {
      return pane.key === accountCenterKey;
    });
    if (index > -1) {
      tabsactions.activateItem(accountCenterKey);
      return;
    }
    tabsactions.addItem({
      key: accountCenterKey,
      title: '账号中心',
      content: {
        type: 'platform',
        url: 'account-center'
      }
    });
  }
  handlePersonalInfo() {
    this.handleAccountCenter();
    const { useractions } = this.props;
    useractions.setAccountActiveKey('personalInfo');
  }
  handleChangePsd() {
    this.handleAccountCenter();
    const { useractions } = this.props;
    useractions.setAccountActiveKey('changePsd');
  }
  handleLogout() {
      cb.utils.confirm('您确定要退出吗？退出系统将关闭当前窗口！', function () {
        cb.route.redirectLoginPage(false);
        if (navigator.userAgent.indexOf("MSIE") > 0) {
          window.opener = null;
          window.close();
        } else if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
          var win = window.open("about:blank", "_self");
          win.close();
        } else {
          window.opener = null;
          window.open('', '_self', '');
          window.close();
        }
      });
    // this.props.tabsactions.clear();
  }
  onChange = (activeKey) => {
    const { tabsactions } = this.props;
    tabsactions.activateItem(activeKey);
  }
  onEdit = (targetKey, action) => {
    this[action](targetKey);
  }
  remove = (key) => {
    const { tabsactions, portalactions, portal } = this.props;
    const current = portal.tabs[key];
    if (!current || !current.panes.length) return;
    const currentPanes = current.panes;
    const activeContent = currentPanes[currentPanes.length - 1].content;
    if (activeContent.vm) {
      activeContent.vm.promiseExecute('return', '关闭', function () {
        tabsactions.deleteItem(key);
      });
    } else if (activeContent.type && activeContent.url) {
      if (activeContent.checkReturn) {
        portalactions.refreshItem(key, '关闭', function () {
          tabsactions.deleteItem(key);
        });
      } else {
        tabsactions.deleteItem(key);
      }
    }
  }
  handleRefresh = () => {
    const { tabs, portalactions, portal } = this.props;
    const { activeKey } = tabs;
    const current = portal.tabs[activeKey];
    if (!current || !current.panes.length) return;
    portalactions.delItem(activeKey);
    const currentPanes = current.panes;
    if (currentPanes.length === 1) {
      const callback = (returnData) => {
        const { title, content, params } = returnData;
        portalactions.addItem(activeKey, { title, content, params });
      };
      cb.loader.runCommandLine('menu', currentPanes[0].params, null, callback);
    } else {
      const { title, content, params, parent } = currentPanes[currentPanes.length - 1];
      if (content.vm) {
        cb.loader.runCommandLine('bill', params, parent);
      } else {
        portalactions.addItem(activeKey, { title, content, params, parent });
      }
    }
  }
  closeOther = () => {
    const { tabsactions, tabs } = this.props;
    tabsactions.closeOther(tabs.activeKey);
  }
  closeAll = () => {
    this.props.tabsactions.closeAll();
  }
  onVisibleChange=(visible)=>{
    if(visible) this.setState({searchValue:''})
  }
  renderTabs(dataSource, titles, activeKey) {
    const operations = (
      <Popover trigger={this.state.trigger} placement='bottom' arrowPointAtCenter content={<div className='title-setting top-right-title'>
        <p><a onClick={this.handleRefresh}>刷新当前页面</a></p>
        <p><a onClick={this.closeOther}>关闭其他页面</a></p>
        <p><a onClick={this.closeAll}>关闭全部页面</a></p></div>}>
        <span className='title-name'><Icon type='shuaxin' /></span>
      </Popover>
    );
    const { tabs } = this.props;
    let width = 0;
    if (tabs.width - 400 > 0) {
      width = tabs.width - 400;
      if (this.rightElement)
        width = width + 400 - this.rightElement.clientWidth + 30;
    }
    let headTitle = '基础服务－';
    const items = [];
    if (dataSource && dataSource.length) {
      dataSource.forEach(item => {
        const title = titles[item.key] && titles[item.key].activeTitle || item.title;
        items.push(<TabPane tab={title} key={item.key} closable={item.closable}></TabPane>);
        if (item.key === activeKey)
          document.title = headTitle + title;
      });
    }
    return (
      <Tabs style={{ width: width, float: 'left' }}
        hideAdd
        onChange={this.onChange}
        activeKey={activeKey}
        type="editable-card"
        onEdit={this.onEdit}
        animated={false}
        tabBarExtraContent={operations}>
        {items}
      </Tabs>
    );
  }
  handleOrgChange(value, name) {
    if(this.props.user.orgId===value) return
    this.props.useractions.changeOrg(value, name);
  }
    /*搜索框改变*/
  onSearchChange = (e) => {
    let value = e.target.value;
    if(value ===''  && this.state.searchValue=='') return
    this.setState({ searchValue: value });
  }
  onSearchClear = () => {
    this.setState({ searchValue: '' })
  }
  renderOrgs() {
    let {searchValue} = this.state;
    let { showOrg, userOrgs, orgId, defaultOrgName } = this.props.user;
    if (!showOrg)
      return null;
    const items = [<Search value={searchValue} onChange ={this.onSearchChange} className="topMenu_Search"/>];
    if(searchValue){
      userOrgs = userOrgs.filter(v=>v.org_name.includes(searchValue))
    }
    let itemsInner = [];
    if(searchValue.length) itemsInner.push(<span onClick={this.onSearchClear} className="ant-select-selection__clear"></span>)
    if (userOrgs && userOrgs.length) {
      userOrgs.forEach(org => {
        itemsInner.push(<p className={orgId === org.org ? 'topMenu_checked' : ''}><a onClick={() => this.handleOrgChange(org.org, org.org_name)}>{org.org_name}{orgId === org.org ? <SvgIcon type="xuanzhong1" /> : null}</a></p>);
      });
    }else{
      if(searchValue){
        itemsInner.push(<p><a>啊哦~没有搜索到~</a></p>)
      }
    }
    items.push(<div>{itemsInner}</div>)
    return itemsInner.length ? <Popover trigger={this.state.trigger} placement='bottom' arrowPointAtCenter content={items} onVisibleChange={this.onVisibleChange}>
      <span className='orgOrStore'><b>{defaultOrgName}</b><Icon type='rowBottom' /></span>
    </Popover> : null;
  }
  handleStoreChange(value, name) {
    this.props.useractions.changeStore(value, name);
  }
  renderStores() {
    const { showStore, userStores, storeId, defaultStoreName } = this.props.user;
    if (!showStore)
      return null;
    const items = [];
    if (userStores && userStores.length) {
      userStores.forEach(store => {
        items.push(<p className={storeId === store.store ? 'topMenu_checked' : ''}><a onClick={() => this.handleStoreChange(store.store, store.store_name)}>{store.store_name}{storeId === store.store ? <SvgIcon type="xuanzhong1" /> : null}</a></p>);
      });
    }
    return items.length ? <Popover trigger={this.state.trigger} placement='bottom' arrowPointAtCenter content={items}>
      <span className='orgOrStore'><b>{defaultStoreName}</b><Icon type='rowBottom' /></span>
    </Popover> : null;
  }
  handleGradeChange(value, name) {
    this.props.useractions.changeGrade(value, name);
  }
  renderGrades() {
    const { showStore, userGrades, gradeId, defaultGradeName } = this.props.user;
    if (!showStore)
      return null;
    const items = [];
    if (userGrades && userGrades.length) {
      userGrades.forEach(grade => {
        items.push(<p className={gradeId === grade.id ? 'topMenu_checked' : ''}><a onClick={() => this.handleGradeChange(grade.id, grade.name)}>{grade.name}{gradeId === grade.id ? <SvgIcon type="xuanzhong1" /> : null}</a></p>);
      });
    }
    return items.length ? <Popover trigger={this.state.trigger} placement='bottom' arrowPointAtCenter content={items}>
      <span className='orgOrStore'><b>{defaultGradeName}</b><Icon type='rowBottom' /></span>
    </Popover> : null;
  }
  clearCache=()=>{
    this.props.tabsactions.addItem({
      key: 'PlatformManagement',
      title: '平台管理',
      content: {
        type: 'platform',
        url: 'platform-management'
      }
    });
  }
  render() {
    const { tabs, portal, user, loading } = this.props;
    let logo = user.logo ? user.logo : '';
    let logoStyle = {};
    if (logo) {
      logoStyle = { backgroundImage: `url(${logo})` }
    }
    return (
      <div>
        {logo ? <div className="logo"><div style={logoStyle} onClick={this.clearCache}></div></div>
          : <div className="logo"><SvgIcon type="jichufuwu" onClick={this.clearCache} /></div>}
        {this.renderTabs(tabs.panes, portal.tabs, tabs.activeKey)}
        <div ref={node => this.rightElement = node} className='top-right'>
          {this.renderOrgs()}
          {/*this.renderStores()}
          {this.renderGrades()}*/}
          <em>{user.avatar ? <img src={user.avatar} /> : null}</em>
          {/*<span className='title-name' style={{cursor:'default'}}>HI，{user.name}</span>*/}
          <Popover trigger={this.state.trigger} content={<div className='title-setting top-right-title'>
            <p><a onClick={() => this.handlePersonalInfo()}><Icon type='user' />个人信息</a></p>
            <p><a onClick={() => this.handleChangePsd()}><Icon type='lock' />修改密码</a></p>
            <p><a onClick={() => this.handleLogout()}><Icon type="poweroff" />退出系统</a></p></div>}>
            <span className='title-name'>HI，{user.name}<Icon type='rowBottom' /></span>
          </Popover>
        </div>
        <div className='TopMenu-loading'>
          <SpinBar loading={loading} />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tabs: state.tabs.toJS(),
    portal: state.portal.toJS(),
    user: state.user.toJS(),
    loading: state.loading
  }
}

function mapDispatchToProps(dispatch) {
  return {
    tabsactions: bindActionCreators(tabsactions, dispatch),
    portalactions: bindActionCreators(portalactions, dispatch),
    useractions: bindActionCreators(useractions, dispatch),
    toggleLoadingStatus: bindActionCreators(toggleLoadingStatus, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);



// WEBPACK FOOTER //
// ./src/common/components/portal/TopMenu.jsx